import { Loading } from 'quasar';
import { sleeper } from '@/lib/tools';
import { app } from '@/main';

const loading = {
  // SHOW
  show(message = 'loading...') {
    Loading.show({
      message: message === 'loading...' ? app.$t(message) : message,
    });
    return Promise.resolve();
  },
  // HIDE
  hide(delay = 0) {
    return sleeper(delay).then(() => {
      Loading.hide();
    });
  },
};

export default loading;
